export function useContentFromMarkdownCodeBlock(blockIdentifier: string, body: string) {
  const regexp = new RegExp(`\`\`\`${blockIdentifier}\n.*\n\`\`\``, "g");
  const [block] = body?.match(regexp) || [];
  const rest = body?.replace(block, "");

  return { block, rest };
}
